module.exports = __webpack_public_path__ + "img/main_button_search_up.fd261bf3.png";